<template>
    <v-container>
        <v-layout>
            <v-chip v-for="m in measures" :key="m.id" v-on:click="selectedMeasure=m">{{m.label}}</v-chip>
        </v-layout>
        <v-layout>
            <v-card>
                <v-card-text>
                    <v-layout>
                        <v-flex xs6>Dimensions</v-flex>
                        <v-flex xs6>{{selectedMeasure.dimension}}</v-flex>
                        <v-flex xs6>Unit</v-flex>
                        <v-flex xs6>{{selectedMeasure.unit}}</v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>
<script>
import { Measure } from "@/store/models/Measure";

export default {

    name: "Measure",

    props:{
        measures: Measure,

    }
}
</script>